import { render, staticRenderFns } from "./chat-icon.vue?vue&type=template&id=418d02d6"
import script from "./chat-icon.vue?vue&type=script&lang=js"
export * from "./chat-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports